import { styled, Typography, type CSSObject } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

export const StyledSection = styled(Section)(({ theme }) => ({
  padding: theme.spacing(12, 0, 24),
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 0),
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  marginBottom: theme.spacing(8),
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: theme.spacing(4),
  },
}));

export const StyledTableAligner = styled('div')(({}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
}));

export const StyledTableWrapper = styled('div')(({ theme }) => ({
  maxWidth: '1000px',
  width: '100%',
  ...theme.mixins.gradientTable('large'),
}));
